import { getSeenInvoiceIds } from './invoiceSeenStorage';

export const INVOICE_QUERY = 'documentType==INVOICE';

export const isNewInvoice = (invoice, clinicId) => {
    if (!invoice?.id || !clinicId) {
        return false;
    }

    return !getSeenInvoiceIds(clinicId).has(invoice.id);
};

export const countNewInvoices = (invoices, clinicId) => (
    (invoices || []).filter((invoice) => isNewInvoice(invoice, clinicId)).length
);
